
const form              = document.querySelector('form.form'),
      bookingDatepicker = document.querySelector('.booking-datepicker'),
      btnAddToCart      = document.querySelector('#add-to-cart'),
      productSelect     = document.querySelector('#product-select'),
      backupSelect      = document.querySelector('#backup-product');

/**
 * @type { ReservationDB }
*/
let reservationDB = null

let planRentSelectedDays = 4

if( btnAddToCart ) {
  btnAddToCart.onclick = justRent
}

window.addEventListener('DOMContentLoaded', async () => {
  const { getBookedDays } = window.proficient.utils

  if( !getBookedDays ) {
    throw new Error('getBookedDays function is not defined')
  }

  try {
    window.setLoading(true)
    let bookedDays = []
    let hasFutureRentPending = false

    const inventories = Array.from(
      document.querySelectorAll('#product-select option[data-inventory]')
    ).map( option => Number( option.getAttribute('data-inventory') ) )

    // first we validate the inventory of each variant by a product
    // if any of these variant has not inventory available we get the 
    // booked days for that variant to block that days in calendar
    if( inventories.some( inventory => inventory <= 1) ) {
      console.info('We need to get the booked days')

      const data = await getBookedDays(PRODUCT_JSON.id)
      // console.log({ data })

      bookedDays = data.bookedDays
      hasFutureRentPending = data.hasFutureRentPending
    } else {
      console.info('no need to get the booked days')
    }

    const dataProficient = window.proficient.data

    window.proficient.data = {
      ...dataProficient,
      bookedDays,
      hasFutureRentPending,
    }

    loadPlanRentSelector()

    // we load the first booked day from initial value of product variant selector
    const mainBookedDays = loadBookedDayFromCurrentVariant(productSelect.value)

    window.proficient.data = {
      ...window.proficient.data,
      mainBookedDays
    }

    window.proficient.utils.generateBlockedDays()

    if( window.proficient.models ) {
      const { ReservationDB } = window.proficient.models

      if( !ReservationDB )
        throw new Error('ReservationDB is not being exported from proficient.models')

      reservationDB = new ReservationDB()
    }

    const pending = reservationDB.getFirstReservationPending()
    
    if( pending ) {
      activeBackupSelection(pending)
      validateBackupInventory()
    } else {
      await verifyReservations()
    }
  } catch (error) {
    console.error(error)
  } finally {
    window.setLoading(false)
  }

  window.localStorage.setItem('last-product-visited', window.location.pathname)
});

/**
 * Verify the cart info.
 * If there are reservations in DB but there are not items on cart,
 * then we clean all reservations
 */
async function verifyReservations() {
  const cart = await window.proficient.utils.getCartInfo()

  if( cart.items.length === 0 ) {
    console.log('Limpiando reservaciones')
    reservationDB.clearDB()
  }
}

/**
 * this validates the product form
 * @returns boolean
 */
function validateForm() {
  if( bookingDatepicker.value === '' ) {
    const required = document.querySelectorAll('.info-required')
    required.forEach( el => {
      el.style.display = 'block'
    })
    return false
  }

  return true
}

async function justRent() {
  const isValid = validateForm()
  if( !isValid ) return

  const product = {
    id: PRODUCT_JSON.id,
    variantId: productSelect.value,
    title: PRODUCT_JSON.title,
    handle: PRODUCT_JSON.handle,
    price: PRODUCT_JSON.price,
  }

  const backup = {
    title: 'Sin backup',
    id: null,
    variantId: null,
    handle: null,
    price: null
  }

  try {
    setLoading(true)
    const startDate = window.proficient.utils.parseLocalDate(bookingDatepicker.value).getTime()

    const params = {
      productId: PRODUCT_JSON.id,
      variantId: productSelect.value,
      startDate,
      rentPlanDurationInDays: planRentSelectedDays
    }
  
    const data = await window.proficient.utils.createReservation(params, true)
  
    const reservation = new Reservation(product, backup, startDate, planRentSelectedDays, null, data.reservation._id, false)

    reservationDB.addReservation(reservation)

    const items = [
      {
        id: productSelect.value,
        quantity: 1,
        properties: {
          'Fecha de inicio': new Date(startDate).toLocaleDateString('es-MX'),
          'Duración': `${reservation.rentPlanDurationInDays} días`,
          'Backup': 'Renta sin backup',
          'Tipo': 'Principal',
          'id': data.reservation._id,
        }
      }
    ]

    const res = await window.proficient.utils.addProductsToCart( items )

    if( res.status === 422 ) {
      setTimeout(() => {
        setLoading(true, 'Validando carrito')
      }, 0)
      setTimeout(() => {
        window.proficient.utils.addProductsToCart( items )
          .finally(() => {
            setLoading(false)
            window.location.replace('/cart')
          })
      }, 4000)
    } else {
      window.location.replace('/cart')
    }
  } catch (error) {
    console.error(error)
  } finally {
    setLoading(false)
  }
}

async function rentDressWithVariantAsBackup() {
  const isValid = validateForm()
  if( !isValid ) return

  setLoading(true)

  const product = {
    id: PRODUCT_JSON.id,
    variantId: productSelect.value,
    title: PRODUCT_JSON.title,
    handle: PRODUCT_JSON.handle,
    price: PRODUCT_JSON.price,
  }

  const backup = {
    ...product,
    variantId: backupSelect.value
  }

  const startDate = window.proficient.utils.parseLocalDate(bookingDatepicker.value).getTime()

  try {
    const params = {
      productId: PRODUCT_JSON.id,
      variantId: productSelect.value,
      backupId: PRODUCT_JSON.id,
      backupVariantId: backupSelect.value,
      startDate,
      rentPlanDurationInDays: planRentSelectedDays
    }

    const data = await window.proficient.utils.createReservation(params)

    const discountCode = data.discountCode.code

    const reservation = new Reservation(product, backup,startDate, planRentSelectedDays, discountCode, data.reservation._id, false )
    reservationDB.addReservation(reservation)

    const items = [
      {
        id: productSelect.value,
        quantity: 1,
        properties: {
          'Fecha de inicio': new Date(startDate).toLocaleDateString('es-MX'),
          'Duración': `${planRentSelectedDays} días`,
          'Backup': 'Cliente eligió backup',
          'Tipo': 'Principal',
          'id': data.reservation._id
        }
      },
      {
        id: backupSelect.value,
        quantity: 1,
        properties: {
          'Fecha de inicio': new Date(startDate).toLocaleDateString('es-MX'),
          'Duración': `${planRentSelectedDays} días`,
          'Backup': 'Cliente eligió backup',
          'Tipo': 'Backup',
          'id': data.reservation._id
        }
      }
    ]

    await window.proficient.utils.addProductsToCart( items )

    window.location.replace('/cart')
  } catch (error) {
    console.log(error)
    setLoading(false)
  }
}

/**
 * this creates a new reservation and add it to
 * localStorage (reservationDB)
 * 
 * @param { string } currentVariantId 
 * @param { ?string } backupVariantId
 * @returns { Reservation }
 */
function prepareReservation(currentVariantId, backupVariantId = '') {
  if( !currentVariantId )
    throw new Error('Current variant is not defined')

  const { Reservation } = window.proficient.models

  const product = {
    variantId: currentVariantId,
    id: PRODUCT_JSON.id,
    handle: PRODUCT_JSON.handle,
    price: PRODUCT_JSON.price,
    title: PRODUCT_JSON.title,
    discountCode: null,
  }

  let backup = null

  if( backupVariantId ) {
    backup = {
      variantId: backupVariantId,
      id: PRODUCT_JSON.id,
      handle: PRODUCT_JSON.handle,
      price: PRODUCT_JSON.price,
      title: PRODUCT_JSON.title,
      discountCode: null,
    }
  }

  const startDate = window.proficient.utils.parseLocalDate(bookingDatepicker.value).getTime()

  const reservation = new Reservation(product, backup,startDate, planRentSelectedDays, null, null, true)

  reservationDB.addReservation(reservation)
  return reservation
}

async function goToBackupCollection() {
  const isValid = validateForm()
  if( !isValid ) return

  setLoading(true)

  try {
    const reservation = prepareReservation(productSelect.value)

    console.log({ reservation })

    const items = [
      {
        id: productSelect.value,
        quantity: 1,
        properties: {
          'Fecha de inicio': new Date(reservation.startDate).toLocaleDateString('es-MX'),
          'Duración': `${reservation.rentPlanDurationInDays} días`,
          'Backup': 'Cliente eligió backup',
          'Tipo': 'Principal',
          'id': null
        }
      }
    ]
  
    const res = await window.proficient.utils.addProductsToCart( items )

    if( res.status === 422 ) {
      console.info('we need to add this item as a pending item')
      cartDB.setPending(items[0])
    }

    window.location.replace('/collections/renta?backup=true')
  } catch (error) {
    console.error(error)
    setLoading(false)
  }
}

/**
 * this changes the UI in product page
 * to continue to dress backup selection process
 */
function activeBackupSelection(reservation) {
  hideNonBackupUI()
  const { product } = reservation

  if( PRODUCT_JSON.price > product.price ) {
    btnAddToCart.value = `Agregar como back up`
    btnAddToCart.textContent = `Agregar como back up`
  } else {
    btnAddToCart.textContent = 'Elegir como backup'
    btnAddToCart.value = 'Elegir como backup'
  }

  btnAddToCart.onclick = async function() {
    console.info('Cargando...')
    
    try {
      await selectBackup(reservation)
    } catch (error) {
      console.error(error)
    }
  }
}

/**
 * this creates a reservation in the server
 * and save the customer's backup selection
 */
async function selectBackup(reservation) {
  const { startDate, rentPlanDurationInDays, product } = reservation

  const params = {
    productId: product.id,
    variantId: product.variantId,
    backupId: PRODUCT_JSON.id,
    backupVariantId: productSelect.value,
    startDate,
    rentPlanDurationInDays
  }

  try {
    setLoading(true, 'agregando al carrito')
    const data = await window.proficient.utils.createReservation(params)

    const backup = {
      id: PRODUCT_JSON.id,
      handle: PRODUCT_JSON.handle,
      title: PRODUCT_JSON.title,
      price: PRODUCT_JSON.price,
      variantId: productSelect.value,
    }

    const discountCode = data.discountCode.code

    reservationDB.updateBackupPending(backup, discountCode, data.reservation._id)

    const items = [
      {
        id: params.backupVariantId,
        quantity: 1,
        properties: {
          'Fecha de inicio': new Date(reservation.startDate).toLocaleDateString('es-MX'),
          'Duración': `${reservation.rentPlanDurationInDays} días`,
          'Backup': 'Cliente eligió backup',
          'Tipo': 'Backup',
          'id': data.reservation._id
        }
      }
    ]

    await window.proficient.utils.addProductsToCart( items )

    const pendingItem = cartDB.getPendingFromDB()
    
    if( pendingItem ) {
      const pendingItem = cartDB.getPendingFromDB()
      setTimeout(() => {
        setLoading(true, 'validando carrito')
      }, 200)

      setTimeout( () => {
        window.proficient.utils.addProductsToCart([ pendingItem ])
          .finally(() => {
            cartDB.clearPending()
            setLoading(false)
            window.location.replace('/cart')
          })
      }, 4000)
    } else {
      window.location.replace('/cart')
    }
  } catch (error) {
    console.error(error)
    console.error('An error occured when trying to create a reservation')
  } finally {
    setLoading(false)
  }
}

/**
 * this function hides all the elements that are not part of
 * backup process flow in the product page.
 */
function hideNonBackupUI() {
  const planRentDiv = document.querySelector('.form .group')
  const datesContainer = document.querySelector('.fecha-container')
  const backupDiv = document.querySelector('#backup-drop')
  const tallas = document.querySelector('.group.tallas b')

  if( planRentDiv ) {
    planRentDiv.style.display = 'none'
  }
  
  if( datesContainer ) {
    datesContainer.style.display = 'none'
  }

  if( backupDiv ) {
    backupDiv.style.display = 'none'
  }

  if( tallas ) {
    tallas.textContent = 'Tallas'
    tallas.style.display = 'inline'
    tallas.style.verticalAlign = 'middle'
    tallas.style.float = 'initial'
  }
}

function validateBackupInventory(){
  const productSelect = document.querySelector('#product-select')
  const options = productSelect.querySelectorAll('option')

  options.forEach((option) => {
    const inventory = Number(option.getAttribute('data-inventory') || 0)

    if( inventory === 0 ) {
      option.remove()
    }
  })

  console.log({ options })

  if( productSelect.children.length === 0 ) {
    console.info('there is not inventory available')
    const addToCart = document.querySelector('#add-to-cart')

    if( !addToCart ) {
      throw new Error('#add-to-cart element should exist')
    }

    addToCart.textContent = 'No disponible - Elige otra talla o vestido'
    // addToCart.value = 'No disponible - Elegir otra talla u otro vestido'

    console.log({ addToCart })

    const divInput = document.querySelector('.group.tallas')

    divInput.style.display = 'none'

    addToCart.onclick = function(e){
      e.preventDefault()
      window.location.replace('/collections/renta')
    }
  }
}

function loadPlanRentSelector() {
  const inputs = document.querySelectorAll('.js-days')
  inputs.forEach((input) => {
    input.addEventListener('change', () => {
      const days = Number(input.value)
      planRentSelectedDays = days

      if( bookingDatepicker ) {
        bookingDatepicker.value = ''
      }

      const plan1Label = document.querySelector('#plan-1')
      const plan2Label = document.querySelector('#plan-2')

      if( days === 4 ) {
        plan1Label.style.display = ''
        plan2Label.style.display = 'none'
      }

      if( days === 8 ) {
        plan1Label.style.display = 'none'
        plan2Label.style.display = ''
      }
    })
  })
}

/**
 * this function disables the current variant option in backup-select element
 * to avoid a duplicated backup dress choice from customer
 * @param { string } value 
 */
function disableCurrentOption(value){
  const options = Array.from(backupSelect.children)
  const currentBackupOption = backupSelect.value

  options.forEach( opt => {
    if( opt.value === value ) {
      opt.setAttribute('disabled', '')
      return
    }

    opt.removeAttribute('disabled', '')
  })

  if( currentBackupOption === value ) {
    backupSelect.value = options[0].value
  }
}

/**
 * this filters the booked days depending of the variant selected 
 * @param { string } value
 */
function loadBookedDayFromCurrentVariant(value) {
  const bookedDays = window.proficient.data.bookedDays || []
  
  const variantBookedDays = bookedDays.filter( day => day.variantId === Number(value) )
  const backupVariantBookedDays = bookedDays.filter( day => day.backupVariantId === Number(value) )

  return [...variantBookedDays, ...backupVariantBookedDays]
}

/**
 * this function change the the form action
 * depending of the value of backup-select element
 * @param { string } value
 * @returns void
 */
function changeFormAction(value) {
  switch (value) {
    case 'Backup':
      console.info('Hay que seleccionar otro vestido de backup')
      btnAddToCart.textContent = 'Agregar y escoger otro vestido'
      btnAddToCart.onclick = async () => await goToBackupCollection()
      break
    case 'No Backup':
      console.info('Sin backup')
      btnAddToCart.onclick = justRent
      btnAddToCart.textContent = 'Rentar'
      break
    default:
      btnAddToCart.onclick = async () => await rentDressWithVariantAsBackup()
      btnAddToCart.textContent = 'Rentar'
      break
  }
}

productSelect.onchange = function(e) {
  const value = e.target.value
  const inventory = Number( e.target.getAttribute('data-inventory') )
  const mainBookedDays = loadBookedDayFromCurrentVariant(value)

  // if inventory of the variant is 1 and there is not a "future rent" opened reservation we don't block the main booked days
  const hasFutureRentPending = window.proficient.data.hasFutureRentPending

  if( inventory === 1 && !hasFutureRentPending ) {
    mainBookedDays = []
    console.info('omitiendo dias bloqueados')
  }

  window.proficient.data = {
    ...window.proficient.data,
    mainBookedDays
  }

  disableCurrentOption(e.target.value)

  window.proficient.utils.generateBlockedDays()
}

backupSelect.onchange = function(e) {
  const value = e.target.value
  const inventory = Number( e.target.getAttribute('data-inventory') )

  let backupBookedDays = loadBookedDayFromCurrentVariant(value)

  changeFormAction(value)
  bookingDatepicker.value = ''

  // if inventory of the variant is 1 and there is not a "future rent" opened reservation we don't block the main booked days
  const hasFutureRentPending = window.proficient.data.hasFutureRentPending

  if( inventory === 1 && !hasFutureRentPending ) {
    backupBookedDays = []
    console.info('omitiendo dias bloqueados')
  }

  window.proficient.data = {
    ...window.proficient.data,
    backupBookedDays
  }

  window.proficient.utils.generateBlockedDays()
}

disableCurrentOption( productSelect.value )
